import { forwardRef, ReactNode } from 'react';
// next
import Head from 'next/head';

// ----------------------------------------------------------------------
// Envolve toda tela e define o <title> da aba - usado em quase todo `pages/*`.
// Antes era um Box do MUI so para poder receber `ref`/`sx`; nenhum chamador do
// projeto passa `sx`, `className` ou qualquer outra prop alem de `title` e
// `children` (conferido via grep em src/pages), entao a troca por uma div
// nativa nao muda nada visivel - so tira a dependencia do MUI.
interface Props {
  title: string;
  meta?: ReactNode;
  children: ReactNode;
  sx?: any;
  [key: string]: any;
}

const Page = forwardRef<HTMLDivElement, Props>(({ children, title = '', meta, sx, ...other }, ref) => (
  <>
    <Head>
      <title>{`${title} | GPShub`}</title>
      {meta}
    </Head>

    {/* `sx` nao e usado por nenhum chamador atual, mas a prop continua aceita
        (sem quebrar contrato) e simplesmente ignorada em silencio, como manda
        a regra de migracao - nunca deixar vazar pro DOM como atributo invalido. */}
    <div ref={ref} {...other}>
      {children}
    </div>
  </>
));

Page.displayName = 'Page';

export default Page;
